/* eslint-disable no-unused-vars */
import { parse } from 'query-string';
import React from 'react';
import parser from 'html-react-parser';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import DokanIcons from '../icon/DokanIcons';

/**
 * @param  {} {icon
 * @param  {} title
 * @param  {} value}
 */
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const DokanOverviewCard = ({ icon, title, value, isCurrency = false, loading = false }) => (
    <Spin indicator={antIcon} spinning={loading}>
        <div className="px-6 py-8 rounded-md border border-primary bg-white flex-1 flex item-start ">
            <div className="">
                <div className="p-10px border border-primary rounded-md">
                    <DokanIcons icon={icon} />
                </div>
            </div>

            <div className="mx-5">
                <h3 className="text-secondary text-md font-medium">{title}</h3>
                <p className="text-lg pt-5 font-bold text-dark">
                    {isCurrency ? parser(value) : `${value}`}
                </p>
            </div>
        </div>
    </Spin>
);

export default DokanOverviewCard;
